import { type FC } from 'react';
import { openResponsiveModal as openResponsiveModalInternal } from './lib';
import {
    type BaseOpenResponsiveModalPayload,
    type ResponsiveContextModalProps,
    type ResponsiveModalsMap,
} from './model';

// eslint-disable-next-line @typescript-eslint/no-empty-interface -- App registries extend this public merge point.
export interface ResponsiveModalsOverride {}

type RegisteredResponsiveModals = ResponsiveModalsOverride extends {
    modals: infer TModals extends ResponsiveModalsMap;
}
    ? TModals
    : ResponsiveModalsMap;

type RegisteredResponsiveModalName = Extract<keyof RegisteredResponsiveModals, string>;

type ResponsiveModalInnerProps<TComponent> =
    TComponent extends FC<ResponsiveContextModalProps<infer TInnerProps>> ? TInnerProps : never;

type RegisteredOpenResponsiveModalPayload = {
    [TModal in RegisteredResponsiveModalName]: Omit<BaseOpenResponsiveModalPayload, 'innerProps' | 'modal'> & {
        innerProps: ResponsiveModalInnerProps<RegisteredResponsiveModals[TModal]>;
        modal: TModal;
    };
}[RegisteredResponsiveModalName];

export type OpenResponsiveModalPayload<TInnerProps extends object | undefined = undefined> = TInnerProps extends object
    ? BaseOpenResponsiveModalPayload<TInnerProps>
    : string extends RegisteredResponsiveModalName
      ? BaseOpenResponsiveModalPayload
      : RegisteredOpenResponsiveModalPayload;

export { ResponsiveModalsProvider } from './ResponsiveModalsProvider';
export { clearResponsiveModals, closeResponsiveModal, updateResponsiveModal } from './lib';
export const openResponsiveModal: (payload: OpenResponsiveModalPayload) => void = openResponsiveModalInternal;
export {
    type ResponsiveContextModalProps,
    type ResponsiveModalsContext,
    type ResponsiveModalsMap,
    type UpdateResponsiveModalPayload,
} from './model';
